// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-root {
    height: 4.5vh;
    font-size: 2vh;
    padding-left: 2vh;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  
  .center-text {
    display: flex;
    justify-content: center; /* Horizontally center the text */
    align-items: center; /* Vertically center the text */
    flex: 1; /* To take remaining space and center the text */
    margin-bottom: 2vh;
    margin-left: -20vh;
    z-index: 1000;
  }
  
  .welcome-msg {
    background-color: #8c00d5;
    color: white;
    width: 20vh;
    align-items: center;
    justify-content: center;
    text-align: center;  
    padding: 1vh;
    border-radius: 1vh;
  }`, "",{"version":3,"sources":["webpack://./src/components/footer/Footer.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,uBAAuB,EAAE,iCAAiC;IAC1D,mBAAmB,EAAE,+BAA+B;IACpD,OAAO,EAAE,gDAAgD;IACzD,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;EACpB","sourcesContent":[".footer-root {\n    height: 4.5vh;\n    font-size: 2vh;\n    padding-left: 2vh;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .center-text {\n    display: flex;\n    justify-content: center; /* Horizontally center the text */\n    align-items: center; /* Vertically center the text */\n    flex: 1; /* To take remaining space and center the text */\n    margin-bottom: 2vh;\n    margin-left: -20vh;\n    z-index: 1000;\n  }\n  \n  .welcome-msg {\n    background-color: #8c00d5;\n    color: white;\n    width: 20vh;\n    align-items: center;\n    justify-content: center;\n    text-align: center;  \n    padding: 1vh;\n    border-radius: 1vh;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
